(function () {
  function shouldShow(trigger) {
    if (!trigger) return true;
    var rect = trigger.getBoundingClientRect();
    // Show once hero ATC area is mostly scrolled past
    return rect.bottom < 80;
  }

  function getHeaderOffset() {
    var selectors = ['sticky-header', '.shopify-section-header-sticky', '#shopify-section-header', '.header-wrapper', 'header'];

    for (var i = 0; i < selectors.length; i += 1) {
      var header = document.querySelector(selectors[i]);
      if (!header) continue;

      var rect = header.getBoundingClientRect();
      var style = window.getComputedStyle(header);
      var isVisibleHeader = rect.height > 0 && (style.position === 'fixed' || style.position === 'sticky' || rect.top <= 1);
      if (isVisibleHeader) return Math.ceil(rect.height) + 12;
    }

    return 12;
  }

  function scrollToTarget(target) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  function init(root) {
    if (!root || root.dataset.vbStickyInit === '1') return;
    root.dataset.vbStickyInit = '1';

    var triggerSelector = root.getAttribute('data-trigger') || '[data-vb-pdp-product]';
    var trigger = document.querySelector(triggerSelector);

    function update() {
      root.classList.toggle('is-visible', shouldShow(trigger));
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    // Re-check after layout/images settle
    setTimeout(update, 300);
    setTimeout(update, 1000);

    var btn = root.querySelector('[data-vb-sticky-atc-btn]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        var href = btn.getAttribute('href') || '';
        if (href && href !== '#' && href !== '#vb-pdp-product' && href !== '#kaching-bundles') return;
        var target = document.querySelector('#kaching-bundles') || document.querySelector('.vb-pdp-product__kaching') || document.querySelector('[data-vb-pdp-product]');
        if (!target) return;
        e.preventDefault();
        scrollToTarget(target);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-vb-pdp-sticky]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-vb-pdp-sticky]') || event.target;
    if (root && root.hasAttribute && root.hasAttribute('data-vb-pdp-sticky')) {
      root.dataset.vbStickyInit = '0';
      init(root);
    }
  });
})();
